import * as types from './mutation-types'
import api from '@/api'
import DisplayAPI from '@/api/display'
import usersAPI from '@/api/users'
import ServiceAPI from '@/api/ServiceAPI'
import DevicesAPI from '@/api/DevicesAPI'
import NotifiersAPI from '@/api/notifiers'

export const fetchUsers = ({ commit }, { service, type }) => {
  if (service === '') {
    service = undefined
  }
  return usersAPI.listUsers({ service, type })
    .then(({ users }) => {
      commit(types.RECEIVED_USERS, { users })
    })
    .catch((err) => {
      console.log(err)
    })
}

export const fetchOperators = ({ commit }, { service }) => {
  return usersAPI.listUsers({ service, type: 'operator' })
    .then(({ operators }) => {
      commit(types.RECEIVED_OPERATORS, { operators })
    })
    .catch((err) => {
      console.log(err)
    })
}

export const fetchNotifiers = ({ commit }) => {
  return NotifiersAPI.listNotifiers()
    .then(({ notifiers }) => {
      commit(types.RECEIVED_NOTIFIERS, { notifiers })
    })
    .catch((err) => {
      console.log(err)
    })
}

export const clearServiceContext = ({ commit }) => {
  commit(types.CLEAR_SERVICE_CONTEXT)
}

export const removeService = ({ commit }, { serviceID }) => {
  return api.deleteService({ serviceID })
    .then(() => {
      commit(types.DELETE_SERVICE, { serviceID })
    })
    .catch((err) => {
      console.log(err)
    })
}

export const fetchService = ({ commit }, service) => {
  return api.getService(service)
    .then(({ service }) => {
      commit(types.RECEIVED_SERVICE, { service })
    })
    .catch((err) => {
      console.log(err)
    })
}

export const updateServiceStatus = ({ commit }, service) => {
  commit(types.RECEIVED_SERVICE, { service })
}

export const fetchNextTicket = ({ commit }, service) => {
  return api.getNextTicket({ service: service })
    .then(({ nextTicket }) => {
      commit(types.RECEIVED_NEXT_TICKET, { nextTicket })
    })
    .catch((err) => {
      console.log(err)
    })
}

export const updateQueueNumber = ({ commit }, { letter, newTicket, nextTicket }) => {
  commit(types.RECEIVED_QUEUE_UPDATE, { letter, newTicket, nextTicket })
}

export const fetchNextTickets = ({ commit }, serviceID) => {
  return api.getNextTickets({ serviceID })
    .then(({ nextTickets }) => {
      commit(types.RECEIVED_NEXT_TICKETS, { nextTickets })
    })
    .catch((err) => {
      console.log(err)
    })
}

export const fetchCurrentTickets = ({ commit }, service) => {
  return DisplayAPI.getCurrentTickets(service)
    .then(({ currentTickets }) => {
      commit(types.RECEIVED_CURRENT_TICKETS, { currentTickets })
    })
    .catch((err) => {
      console.log(err)
    })
}

export const fetchCurrentTicket = ({ commit }, service) => {
  return api.getCurrentTicket(service)
    .then(({ ticket }) => {
      commit(types.RECEIVED_CURRENT_TICKET, { ticket })
    })
    .catch((err) => {
      console.log(err)
    })
}

export const fetchTicketsWaitingCount = ({ commit }, service) => {
  return api.getTicketsWaitingCount(service)
    .then(({ ticketsWaitingCount }) => {
      commit(types.RECEIVED_TICKETS_WAITING_COUNT, { ticketsWaitingCount })
    })
    .catch((err) => {
      console.log(err)
    })
}

export const fetchServiceWorker = ({ commit }, service, username) => {
  return api.getServiceWorker(service, username)
    .then(({ worker }) => {
      commit(types.RECEIVED_WORKER, { worker })
    })
    .catch((err) => {
      console.log(err)
    })
}

export const fetchServiceDevices = ({ commit }, { status, serviceID }) => {
  return ServiceAPI.getDevices({ status, serviceID })
    .then(({ devices }) => {
      commit(types.RECEIVED_DEVICES, { devices })
    })
    .catch((err) => {
      console.log(err)
    })
}

export const fetchDevices = ({ commit }, { status }) => {
  return DevicesAPI.getDevices({ status })
    .then(({ devices }) => {
      commit(types.RECEIVED_DEVICES, { devices })
    })
    .catch((err) => {
      console.log(err)
    })
}

export const fetchServiceWorkers = ({ commit }, service) => {
  return api.getServiceWorkers(service)
    .then(({ workers }) => {
      commit(types.RECEIVED_WORKERS, { workers })
    })
    .catch((err) => {
      console.log(err)
    })
}

export const fetchProfile = ({ commit }) => {
  return api.getProfile()
    .then(({ loggedUser }) => {
      commit(types.RECEIVED_LOGGED_USER, { loggedUser })
    })
    .catch((err) => {
      console.log(err)
    })
}

export const fetchNews = ({ commit }) => {
  return DisplayAPI.getNews()
    .then(({ news }) => {
      commit(types.RECEIVED_NEWS, { news })
    })
    .catch((err) => {
      console.log(err)
    })
}

export const fetchServices = ({ commit }) => {
  return api.listServices()
    .then(({ services }) => {
      commit(types.RECEIVED_SERVICES, { services })
    })
    .catch((err) => {
      console.log(err)
    })
}

export const fetchFenixUser = ({ commit }, { username }) => {
  return api.getFenixUser({ username })
    .then(({ user }) => {
      commit(types.RECEIVED_FENIX_USER, { user })
    })
    .catch((err) => {
      clearFenixUser()
      console.log(err)
    })
}

export const clearFenixUser = ({ commit }) => {
  commit(types.CLEAR_FENIX_USER)
}

export const setCurrentTicket = ({ commit }) => {
  commit(types.SET_CURRENT_TICKET)
}
